module.exports = __webpack_public_path__ + "img/cooker-dome-mixer_140x116.64e25bb6.png";